import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper
} from '@mui/material';
import {
  BarChart,
  LineChart,
  PieChart,
  ScatterChart
} from '@mui/x-charts';

const MUICharts = ({ userData, policyData, claimData }) => {
  // Prepare user distribution data
  const userDistributionData = [
    { name: 'Farmers', value: userData?.farmers || 0 },
    { name: 'Agents', value: userData?.agents || 0 },
    { name: 'Admins', value: userData?.admins || 0 }
  ].filter(item => item.value > 0);

  // Prepare policy status data
  const policyStatusData = [
    { name: 'Active', value: policyData?.activePolicies || 0 },
    { name: 'Pending', value: policyData?.pendingPolicies || 0 },
    { name: 'Total', value: policyData?.totalPolicies || 0 }
  ].filter(item => item.value > 0);

  // Monthly trend data (sample for now - can be replaced with real data)
  const monthlyTrendData = [
    { month: 'Jan', policies: Math.floor((policyData?.totalPolicies || 100) * 0.1), claims: Math.floor((claimData?.totalClaims || 50) * 0.1) },
    { month: 'Feb', policies: Math.floor((policyData?.totalPolicies || 100) * 0.15), claims: Math.floor((claimData?.totalClaims || 50) * 0.15) },
    { month: 'Mar', policies: Math.floor((policyData?.totalPolicies || 100) * 0.18), claims: Math.floor((claimData?.totalClaims || 50) * 0.18) },
    { month: 'Apr', policies: Math.floor((policyData?.totalPolicies || 100) * 0.2), claims: Math.floor((claimData?.totalClaims || 50) * 0.2) },
    { month: 'May', policies: Math.floor((policyData?.totalPolicies || 100) * 0.22), claims: Math.floor((claimData?.totalClaims || 50) * 0.25) },
    { month: 'Jun', policies: Math.floor((policyData?.totalPolicies || 100) * 0.15), claims: Math.floor((claimData?.totalClaims || 50) * 0.12) }
  ];

  // Claims status data
  const claimsStatusData = [
    { name: 'Total Claims', value: claimData?.totalClaims || 0 },
    { name: 'Pending Claims', value: claimData?.pendingClaims || 0 }
  ].filter(item => item.value > 0);

  return (
    <>
      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Policy Status Distribution
            </Typography>
            <Box sx={{ height: 300 }}>
              {policyStatusData.length > 0 ? (
                <BarChart
                  xAxis={[{ scaleType: 'band', data: policyStatusData.map(d => d.name) }]}
                  series={[
                    { data: policyStatusData.map(d => d.value), label: 'Policies' }
                  ]}
                  height={300}
                />
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                  <Typography color="text.secondary">No policy data available</Typography>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Monthly Trend: Policies vs Claims
            </Typography>
            <Box sx={{ height: 300 }}>
              <LineChart
                xAxis={[{ scaleType: 'band', data: monthlyTrendData.map(d => d.month) }]}
                series={[
                  { data: monthlyTrendData.map(d => d.policies), label: 'Policies', color: '#1976d2' },
                  { data: monthlyTrendData.map(d => d.claims), label: 'Claims', color: '#dc004e' }
                ]}
                height={300}
              />
            </Box>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Claims Overview
            </Typography>
            <Box sx={{ height: 300 }}>
              {claimsStatusData.length > 0 ? (
                <BarChart
                  xAxis={[{ scaleType: 'band', data: claimsStatusData.map(d => d.name) }]}
                  series={[
                    { data: claimsStatusData.map(d => d.value), label: 'Claims', color: '#2e7d32' }
                  ]}
                  height={300}
                />
              ) : (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                  <Typography color="text.secondary">No claims data available</Typography>
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default MUICharts;
